import { User } from 'firebase/auth';

export interface AuthState {
  user: User | null;
  loading: boolean;
}

export enum AuthActionTypes {
  SET_USER = 'SET_USER',
  LOGOUT = 'LOGOUT',
  SET_LOADING = 'SET_LOADING',
}

interface SetUserAction {
  type: AuthActionTypes.SET_USER;
  payload: User | null;
}

interface LogoutAction {
  type: AuthActionTypes.LOGOUT;
}

interface SetLoadingAction {
  type: AuthActionTypes.SET_LOADING;
  payload: boolean;
}

export type AuthAction = SetUserAction | LogoutAction | SetLoadingAction;

export interface AuthContextType {
  state: AuthState;
  dispatch: React.Dispatch<AuthAction>;
}
